// eslint-disable-next-line @atlaskit/ui-styling-standard/use-compiled -- Ignored via go/DSP-18766

// eslint-disable-next-line no-barrel-files/no-barrel-files
export { zIndex } from './z-index';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { primaryTextColour } from './primary-text-colour';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { itemLinkSecondaryColor } from './item-link-secondary-color';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { itemHighlightColor } from './item-highlight-color';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { visitedLinkColor } from './visited-link-color';
// eslint-disable-next-line no-barrel-files/no-barrel-files
export { nowrapEllipsis } from './nowrap-ellipsis';

const AkGrid = (num: number = 1) => ({
	px: `${num * 8}px`,
	unitless: num * 8,
	multiple: (multiplier: number) => AkGrid(multiplier * num),
	half: () => AkGrid(0.5 * num),
	twice: () => AkGrid(2 * num),
});

export const grid: {
	px: string;
	unitless: number;
	multiple: (multiplier: number) => any;
	half: () => any;
	twice: () => any;
} = AkGrid(1);

export const atlassianNavigationHeight = '56px';

export const collapsedSearchInputWidth = '200px';
export const filterLabelWidth = '150px';

export const dialogWidth = '780px';
export const dialogPageTakeoverWidth: number = 780;
export const dialogPageCentreWidth = '1130px';

export const inputFieldHeight: {
	px: string;
	unitless: number;
	multiple: (multiplier: number) => any;
	half: () => any;
	twice: () => any;
} = grid.multiple(4);
export const enlargedInputFieldHeight: {
	px: string;
	unitless: number;
	multiple: (multiplier: number) => any;
	half: () => any;
	twice: () => any;
} = grid.multiple(6);
